import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChatBubble = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M22 5C22 4.44772 21.5523 4 21 4H3C2.44772 4 2 4.44772 2 5V16C2 16.5523 2.44772 17 3 17H6V19C6 19.3788 6.214 19.725 6.55279 19.8944C6.89157 20.0638 7.29698 20.0273 7.6 19.8L11.3333 17H21C21.5523 17 22 16.5523 22 16V5ZM20 6V15H11C10.7836 15 10.5731 15.0702 10.4 15.2L8 17V16C8 15.4477 7.55229 15 7 15H4V6H20Z",
		fill: "currentColor"
	})
});
export default SvgChatBubble;
